export default __webpack_public_path__ + "content/media/4.dd150bb7.jpg";